module.exports = __webpack_public_path__ + "img/1_008.3521523b.jpg";